<template>
  <div>
    <v-btn
      small
      rounded
      class="navbar-brand v-primary"
      v-b-toggle.menu
      @click="sidebarIsVisible = true"
    >
      <span class="fa fa-bars"></span>
    </v-btn>
    <b-sidebar
      no-slide
      v-show="sidebarIsVisible"
      id="menu"
      title="SISTEMA CLIN"
      backdrop-variant="dark"
      backdrop
      shadow
      @shown="updatePermissions"
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <template v-if="!item.items && item.show">
            <v-list-item :key="index" :to="item.to">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-else-if="item.show">
            <v-list-group :key="index" :prepend-icon="item.action" no-action>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="child in item.items"
                :key="child.title"
                :to="child.to"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
        </template>
      </v-list>
    </b-sidebar>
  </div>
</template>

<script>
import routes from "../routes";

import { adminData } from "../lib/functions";

export default {
  name: "Sidebar",

  data() {
    return {
      admin_id: null,

      sidebarIsVisible: true,

      items: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      let {
        admin: { id },
      } = adminData();

      this.admin_id = id;

      this.updatePermissions();
    },

    updatePermissions() {
      this.items = [
        {
          title: "DASHBOARD",
          show: true,
          to: "/dashboard",
        },
        {
          title: "IMPLANTAÇÃO",
          show: this.admin_id == 1,
          items: [
            { title: "PERMISSÕES", to: "/rest-home-permissions" },
            {
              title: "FORMULÁRIOS DE SEMIOLOGIA",
              to: "/rest-home-semiology-forms",
            },
            { title: "GRUPOS DE USUÁRIO", to: "/rest-home-user-groups" },
            { title: "PERFIS DE USUÁRIO", to: "/rest-home-user-profiles" },
            {
              title: "UNIDADES DE MEDIDA",
              to: "/rest-home/units-of-measurement",
            },
          ],
        },
        {
          title: "MÓDULOS",
          to: "modules",
          show: this.admin_id == 1,
        },
        {
          title: "PLANOS",
          to: "plans",
          show: this.admin_id == 1,
        },
        {
          title: "CLIENTES",
          to: "clients",
          show: true,
        },
        {
          title: "ATUALIZAÇÃO",
          to: "system-update",
          show: this.admin_id == 1,
        },
        {
          title: "MEDICAMENTOS PADRÕES",
          to: "medicine",
          show: this.admin_id == 1,
        },
        {
          title: "FILIAIS",
          to: "branches",
          show: this.admin_id == 1,
        },
      ];
    },

    handlePage(name) {
      if (routes.currentRoute.name !== name) {
        routes.push({ name });
      } else {
        this.sidebarIsVisible = false;
      }
    },
  },
};
</script>